export default {"src":"/_next/static/media/marketplace-banner.ea57efa3.gif","height":200,"width":600,"blurWidth":0,"blurHeight":0};